<bn-loading-overlay></bn-loading-overlay>

<section class="pesquisa">
  <div class="container">
    <div class="mb-3 row">
      <div class="col">
        <h3>Cadastro de CNAE de Grandes Empresas permitido operar</h3>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-danger" (click)="voltarTelaCnaesPermitidos()">Cancelar</button>
      </div>
      <div class="col-auto">
        <button type="button" [disabled]="!validarCamposObrigatorios() || listaCnaesForSave.length === 0"  class="btn btn-success" (click)="salvar()">
          Salvar
        </button>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table">
        <thead>
          <tr>
            <th scope="col"></th>
            <th scope="col">
              Máscara *
            </th>
            <th scope="col">
              Início da validade de permissão *
            </th>
            <th scope="col">
              Tipo da operação
            </th>
            <th scope="col">
              Objetivo do financiamento
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listaCnaesForSave; let i = index">
            <td class="align-middle">
              <div>
                <a 
                  class="fa fa-trash cursor-pointer text-danger"
                  placement="bottom"
                  ngbTooltip="Excluir linha"
                  (click)="removerLinha(i)"
                >
                </a>
              </div>
            </td>
            <td class="text-center">
              <div class="mw-130">
                <ng-select 
                  [items]="codigosCnae" 
                  bindLabel="codigo"
                  bindValue="codigo" 
                  placeholder="Selecione" 
                  [(ngModel)]="item.mascara">
                </ng-select>
              </div>
            </td>
            <td class="text-center">
              <bn-datepicker 
                idInput="dataInicioValidadePermissao" 
                ngDefaultControl
                [(ngModel)]="item.dataInicioValidade" 
                [minDate]="dataHoje" 
                [required]="true">
              </bn-datepicker>
            </td>
            <td class="text-center">
              <select 
                id="tipoOperacao" 
                class="form-select" 
                [(ngModel)]="item.tipoOperacao">
                <option [ngValue]=null>Selecione</option>
                <option [ngValue]="operacao.value" *ngFor="let operacao of tipoOperacaoSelect">
                  {{operacao.label}}
                </option>
              </select>
            </td>
            <td class="text-center">
              <select 
                id="objetivoFinanciamento" 
                class="form-select" 
                [(ngModel)]="item.objetivoFinanciamento">
                <option [ngValue]=null>Selecione</option>
                <option [ngValue]="objetivo.value" *ngFor="let objetivo of objetivoFinanciamentoSelect">
                  {{objetivo.label}}
                </option>
              </select>
            </td>
          </tr>    
        </tbody>
      </table>
      <div class="min-margin">
        <div>
          <a 
            class="fa fa-plus-circle cursor-pointer" 
            placement="bottom"
            ngbTooltip="Adicionar linha"
            (click)="adicionarLinha()"
          >
          </a>
        </div>
        <div class="mt-3">
          <span><b>* Campos obrigatórios</b></span>
        </div>
        <div class="mt-1">
          <span><b>* Máximo 10 máscaras por cadastro</b></span>
        </div>
      </div>
    </div>
  </div>

</section>